// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_PUf","cls2":"SearchBox-cls2_ZUv SearchBox-cls1_PUf"};